import { combineEpics } from "redux-observable";
import { rootEpic as rootEpic$1 } from "@ane/exp-ux/lib/components/SelectExperimentationGroup/LoadExperimentationGroups.epics";
import isolationGroupEpics from "@ane/isolation-group-app-module/lib/module/epics";
import analysisConfigModuleEpic from "@ane/analysis-config-app-module/lib/module/epics";
const epics = [rootEpic$1, isolationGroupEpics, analysisConfigModuleEpic];
const rootEpic = combineEpics(...epics);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
